import { BundleTag } from '@inkitt/galatea-common/types/payment-backend/entities/payment-bundle';
import { PointsBundle } from '../../types/PointsBundle';

export const defaultPointsGalateaSmallPack: PointsBundle = {
  id: 'com.colt.app.tattoos.10',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: 'product_description_4_chapters',
  tags: [BundleTag.Default],
};

export const defaultPointsGalateaMediumPack: PointsBundle = {
  id: 'com.colt.app.tattoos.25',
  adjustEventId: 'p2ol19',
  tiers: 110,
  title: '110 Points',
  description: 'product_description_11_chapters',
  tags: [BundleTag.Default],
};

export const defaultPointsGalateaBigPack: PointsBundle = {
  id: 'com.colt.app.tattoos.40',
  adjustEventId: 'p2ol19',
  tiers: 250,
  title: '250 Points',
  description: 'product_description_25_chapters',
  tags: [BundleTag.Default],
};

export const defaultPointsGalateaBiggerPack: PointsBundle = {
  id: 'com.colt.app.points.bigger',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: 'product_description_55_chapters',
  tags: [BundleTag.Default],
};

export const points40GalateaFor399: PointsBundle = {
  id: 'com.colt.app.points.399',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points110GalateaFor799: PointsBundle = {
  id: 'com.colt.app.points.799',
  adjustEventId: 'p2ol19',
  tiers: 110,
  title: '110 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points250GalateaFor1399: PointsBundle = {
  id: 'com.colt.app.points.1399',
  adjustEventId: 'p2ol19',
  tiers: 250,
  title: '250 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points550GalateaFor2499: PointsBundle = {
  id: 'com.colt.app.points.2499',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points40GalateaFor799: PointsBundle = {
  id: 'com.colt.app.points.799',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points110GalateaFor1299: PointsBundle = {
  id: 'com.colt.app.points.1299',
  adjustEventId: 'p2ol19',
  tiers: 110,
  title: '110 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points250GalateaFor2499: PointsBundle = {
  id: 'com.colt.app.points.2499',
  adjustEventId: 'p2ol19',
  tiers: 250,
  title: '250 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points550GalateaFor3999: PointsBundle = {
  id: 'com.colt.app.points.3999',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points1500GalateaFor3999: PointsBundle = {
  id: 'com.colt.app.points.3999',
  adjustEventId: 'p2ol19',
  tiers: 1500,
  title: '1500 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points3000GalateaFor6999: PointsBundle = {
  id: 'com.colt.app.points.6999',
  adjustEventId: 'p2ol19',
  tiers: 3000,
  title: '3000 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points1500GalateaFor5999: PointsBundle = {
  id: 'com.colt.app.points.5999',
  adjustEventId: 'p2ol19',
  tiers: 1500,
  title: '1500 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const points3000GalateaFor9999: PointsBundle = {
  id: 'com.colt.app.points.9999',
  adjustEventId: 'p2ol19',
  tiers: 3000,
  title: '3000 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const pointsSMHigher1: PointsBundle = {
  id: 'com.colt.points.sm.higher1',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const pointsMDHigher1: PointsBundle = {
  id: 'com.colt.points.md.higher1',
  adjustEventId: 'p2ol19',
  tiers: 110,
  title: '110 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const pointsLGHigher1: PointsBundle = {
  id: 'com.colt.points.lg.higher1',
  adjustEventId: 'p2ol19',
  tiers: 250,
  title: '250 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const pointsXLHigher1: PointsBundle = {
  id: 'com.colt.points.xl.higher1',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const pointsSMLower1: PointsBundle = {
  id: 'com.colt.points.sm.lower1',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const pointsMDLower1: PointsBundle = {
  id: 'com.colt.points.md.lower1',
  adjustEventId: 'p2ol19',
  tiers: 110,
  title: '110 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const pointsLGLower1: PointsBundle = {
  id: 'com.colt.points.lg.lower1',
  adjustEventId: 'p2ol19',
  tiers: 250,
  title: '250 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const pointsXLLower1: PointsBundle = {
  id: 'com.colt.points.xl.lower1',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const discountedPointsSM: PointsBundle = {
  id: 'com.colt.points.sm.discounted',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const discountedPointsMD: PointsBundle = {
  id: 'com.colt.points.md.discounted',
  adjustEventId: 'p2ol19',
  tiers: 110,
  title: '110 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const discountedPointsLG: PointsBundle = {
  id: 'com.colt.points.lg.discounted',
  adjustEventId: 'p2ol19',
  tiers: 250,
  title: '250 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const discountedPointsXL: PointsBundle = {
  id: 'com.colt.points.xl.discounted',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const discountedPointsXXL: PointsBundle = {
  id: 'com.colt.points.xxl.discounted',
  adjustEventId: 'p2ol19',
  tiers: 850,
  title: '850 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const discountedPointsXXXL: PointsBundle = {
  id: 'com.colt.points.xxxl.discounted',
  adjustEventId: 'p2ol19',
  tiers: 1500,
  title: '1500 Points',
  description: '',
  tags: [BundleTag.Default],
};

export const internationalPointsSM: PointsBundle = {
  id: 'com.colt.points.sm.international',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: 'international pricing test small points package',
  tags: [BundleTag.Default],
};

export const internationalPointsMD: PointsBundle = {
  id: 'com.colt.points.md.international',
  adjustEventId: 'p2ol19',
  tiers: 110,
  title: '110 Points',
  isRecommended: true,
  isMostPopular: true,
  description: 'international pricing test medium points package',
  tags: [BundleTag.Default],
};

export const internationalPointsLG: PointsBundle = {
  id: 'com.colt.points.lg.international',
  adjustEventId: 'p2ol19',
  tiers: 250,
  title: '250 Points',
  description: 'international pricing test large points package',
  tags: [BundleTag.Default],
};

export const internationalPointsXL: PointsBundle = {
  id: 'com.colt.points.xl.international',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: 'international pricing test extra large points package',
  tags: [BundleTag.Default],
};

export const internationalV2PointsSM: PointsBundle = {
  id: 'com.colt.points.sm.international.v2',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: 'international pricing test small points package',
  tags: [BundleTag.Default],
};

export const internationalV2PointsMD: PointsBundle = {
  id: 'com.colt.points.md.international.v2',
  adjustEventId: 'p2ol19',
  tiers: 110,
  title: '110 Points',
  isRecommended: true,
  isMostPopular: true,
  description: 'international pricing test medium points package',
  tags: [BundleTag.Default],
};

export const internationalV2PointsLG: PointsBundle = {
  id: 'com.colt.points.lg.international.v2',
  adjustEventId: 'p2ol19',
  tiers: 250,
  title: '250 Points',
  description: 'international pricing test large points package',
  tags: [BundleTag.Default],
};

export const internationalV2PointsXL: PointsBundle = {
  id: 'com.colt.points.xl.international.v2',
  adjustEventId: 'p2ol19',
  tiers: 550,
  title: '550 Points',
  description: 'international pricing test extra large points package',
  tags: [BundleTag.Default],
};

export const goldenHourPointsSM: PointsBundle = {
  id: 'com.colt.app.points.sm.golden.hour',
  adjustEventId: 'p2ol19',
  tiers: 40,
  title: '40 Points',
  description: '',
  tags: [BundleTag.Default],
};
